export function parseCheckoutRevenue(value) {
  if (value == null || value === "") return null;
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return amount;
}

export function isCheckoutTrial({
  urlTrial,
  urlFeaturesPlanTrial,
  formTrial,
} = {}) {
  return (
    urlTrial === "true" ||
    urlFeaturesPlanTrial === "true" ||
    formTrial === "true"
  );
}

export function checkoutAttributionParams($form, getUrlParameter) {
  const formAccountId = $form
    ? $form.find("[name='subscription[account_id]']").val()
    : undefined;
  const formStripePlan = $form
    ? $form.find("[name='subscription[stripe_plan]']").val()
    : undefined;
  const formTrial = $form
    ? $form.find("[name='subscription[trial]']").val()
    : undefined;
  const formRevenue = $form ? $form.attr("data-plan-monthly-price") : undefined;

  return {
    accountId:
      formAccountId || (getUrlParameter && getUrlParameter("account_id")),
    stripePlan:
      formStripePlan ||
      (getUrlParameter &&
        (getUrlParameter("features_plan_id") ||
          getUrlParameter("stripe_plan") ||
          getUrlParameter("plan_id"))),
    trial: isCheckoutTrial({
      urlTrial: getUrlParameter && getUrlParameter("trial"),
      urlFeaturesPlanTrial:
        getUrlParameter && getUrlParameter("features_plan_trial"),
      formTrial,
    }),
    revenue: parseCheckoutRevenue(formRevenue),
  };
}

export function trackPurchaseWhenReady(convertflow, payload, addEventListener) {
  if (convertflow && typeof convertflow.trackPurchase === "function") {
    convertflow.trackPurchase(payload);
    return true;
  }

  const listen =
    addEventListener ||
    (typeof window !== "undefined" && window.addEventListener);
  if (typeof listen === "function") {
    listen.call(window, "cfReady", function onCfReady() {
      if (
        window.convertflow &&
        typeof window.convertflow.trackPurchase === "function"
      ) {
        window.convertflow.trackPurchase(payload);
      }
    });
  }

  return false;
}

export function trackCheckoutAttribution({
  stripePlan,
  accountId,
  trial,
  revenue,
  convertflow,
  dataLayer,
  addEventListener,
} = {}) {
  if (!stripePlan || !accountId) {
    return { tracked: false };
  }

  const amount = parseCheckoutRevenue(revenue);
  const layer =
    dataLayer || (typeof window !== "undefined" && window.dataLayer);
  const prefix = trial ? "cf_start_trial" : "cf_purchase";

  if (layer && typeof layer.push === "function") {
    layer.push({ event: prefix });
  }

  if (amount == null) {
    return { tracked: false, trial };
  }

  const payload = { revenue: amount, order_id: String(accountId) };
  const tracked = trackPurchaseWhenReady(
    convertflow,
    payload,
    addEventListener
  );

  return {
    tracked,
    trial,
    revenue: amount,
  };
}

export default trackCheckoutAttribution;
